export default __webpack_public_path__ + "static/yall-logo-b3c5aeb2f61543351bbe3d55e9c3d960.png";